import { Testimonal } from './../data-types/data-types';
export const testimonials: Testimonal[] = [
	{
		name: "S. O.",
		isParent: false,
		age: 15,
		gender: "Male",
		body: "SMARTA Coaching helped me to become more focused, confident, and organized. I learned how to set my goals, and my short-term and long-term goals into actionable steps. SMARTA helped me to focus on the most important things in life and not to be distracted by other things.",
	},
	{
		name: "N. O.",
		isParent: true,
		body: "As a mom with teens, this is very insightful, and it goes a long way to help you know how to relate with your teenager. God bless you. Keep up the good work",
	},
	{
		name: "Mrs. D. Femi-A.",
		isParent: true,
		body: "The boot camp really helped my daughter to set her priorities well. She behaves more maturely. She has improved in her communication with her siblings. My son is always eager to sit at the session. He is becoming more tolerant compared to beforehand.",
	},
	{
		name: "E. A.",
		isParent: false,
		age: 16,
		gender: "Female",
		body: "The program laid out by SMARTA Teens Coaching is structured in a way that makes it easily relatable and applicable to teens. The lessons taught through the online sessions are impactful and they aren't just one size fits all, they are tailored to each student's individual needs. The session was impactful and an eye-opener to many things. I got to understand the power of reflection i.e. the bedrock of living a better life and breaking cycles. Likewise, I was more open to the importance of goal setting. I have shared this with my colleagues who are looking forward to seeing you again for the next set of sessions.",
	},
	{
		name: 'Mrs. O.A.',
		isParent: true,
		body: "I also wanted to let you know that the sessions were engaging and my children said you were accommodating. No judgments. The sixteen personality traits were very revealing to my children. They understood themselves better and their love languages. They are now communicating their needs more effectively to one another which is a priceless gift.",
	},
	{
		name: "M. O.",
		isParent: false,
		age: 16,
		gender: "Female",
		body: "I highly recommend the SMARTA Teens program to everyone, it is an amazing experience! I learned a lot in this program and a few of them is that there is no dream that is small to achieve, we are born to be a solution to another person’s problem, and we should break our entitlement mindset. I really enjoyed the camp and I am so happy I found such a great experience. Great and useful tips in this program. I'm a huge fan of SMARTA teens coaching since I joined the camp last year. ",
	},
	{
		name: "O. A.",
		isParent: false,
		age: 12,
		gender: "Male",
		body: "Your sessions were like a Chicken burger. They make me stronger. ",
	},
]